import BemIt, { addClass } from "@gtechdoodler/bem-it";
import StyledActionButton from "./styling/ActionButton.styles";
import Icon from "../../imagery/Icon";
import Typography from "../../typography/Typography";
import { ActionButtonProps } from "./ActionButton.types";

const ActionButton: React.FC<ActionButtonProps> = ({
	className,
	text,
	icon,
	iconPosition = "right",
	variant = "nonquiet",
	colorOn = "bg_white",
	...props
}) => {
	const block = new BemIt("ActionButton");
	const iconOnly = !text && Boolean(icon);
	const iconSize = iconOnly ? "md" : "sm";

	return (
		<StyledActionButton
			className={addClass(className).after(block)}
			variant={variant}
			colorOn={colorOn}
			iconOnly={iconOnly}
			iconPosition={iconPosition}
			{...props}
		>
			<Typography weight="heaviest">{text}</Typography>
			{icon && <Icon name={icon} size={iconSize} />}
		</StyledActionButton>
	);
};

export default ActionButton;
